import utils from "@/utils";
import { Controller } from "@hotwired/stimulus";

/** 
 * A controller to automatically open the dropdown when a search term is entered. 
 * Must be put on the dropdown element. 
 **/
export default class DropdownFilterController extends Controller<HTMLElement> {

    static classes = ['input'];

    declare readonly inputClass: string;

    public inputElement: HTMLInputElement;

    initialize(): void {
        utils.addControllerAction(this, { event: 'keydown', method: 'open' });
        utils.addControllerAction(this, { event: 'menu-open', method: 'focusInput' });
    }

    connect() {
        this.inputElement = this.element.querySelector(`.${this.inputClass}`);
    }

    open() {
        if (!utils.hasController(this.element, 'dropdown-menu')) {  // Or else disconnect when dropdown-menu open
            this.element.dispatchEvent(new Event('open'));
            this.inputElement.value = '';
        }
    }

    focusInput() {
        this.inputElement.focus();
    }
}
